import React from 'react';
import PropTypes from 'prop-types';
import bgImage from '../../assets/images/bg-auth.png';

const BackgroundIllustrations = ({ className = '' }) => (
 <div
   className={`${className} bg-cover bg-center bg-no-repeat`}
   style={{ backgroundImage: `url(${bgImage})` }}
 >
   <div className="lightning-bolt"></div>
   <div className="heart"></div>
   <div className="infinity-symbol"></div>
 </div>
);

BackgroundIllustrations.propTypes = {
 className: PropTypes.string
};

export default BackgroundIllustrations;